


































import Toolbar from '@/components/Toolbar.vue';
import { State } from '@/store/State';
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { ExportService } from './ExportService';

@Component({
  components: {
    Toolbar,
  },
})
export default class ExportSurveys extends Vue {
  @Inject('exportService')
  private exportService!: ExportService;

  private downloadUrl: string | null = null;
  private loading = true;

  private get defaultExport() {
    return (this.$store.state as State).defaultExport;
  }

  private get lastUpdatedAt() {
    const defaultExport = this.defaultExport;
    return defaultExport === null ? null : defaultExport.lastUpdatedAt;
  }

  private get path() {
    const defaultExport = this.defaultExport;
    return defaultExport === null ? null : defaultExport.path;
  }

  @Watch('defaultExport')
  private async syncDownloadUrl() {
    const path = this.path;
    if (path) {
      this.downloadUrl = await this.exportService.downloadUrl(path);
    } else {
      this.downloadUrl = null;
    }
  }

  private async created() {
    await this.$store.dispatch('bindDefaultExport');
    await this.syncDownloadUrl();
    this.loading = false;
  }

  private destroyed() {
    this.$store.dispatch('unbindDefaultExport');
  }

  private async exportSurveys() {
    await this.exportService.exportSurveysAndEmployeeData();
  }
}
